(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-hero-track]');
      this.slides = Array.from(el.querySelectorAll('[data-hero-slide]'));
      this.current = el.querySelector('[data-hero-current]');
      this.progress = el.querySelector('[data-hero-progress]');
      this.index = 0;
      this.timer = null;

      const prev = el.querySelector('[data-hero-prev]');
      const next = el.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      this.update();

      if (el.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.start();
        el.addEventListener('mouseenter', () => this.stop());
        el.addEventListener('mouseleave', () => this.start());
      }
    }

    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.update();
    }

    update() {
      const n = this.index + 1;
      if (this.current) this.current.textContent = n < 10 ? '0' + n : '' + n;
      if (this.progress) {
        this.progress.style.width = (n / this.slides.length) * 100 + '%';
      }
    }

    start() {
      const interval = parseInt(this.el.dataset.interval, 10) || 5000;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.querySelectorAll('[data-hero]').forEach((el) => new HeroSlider(el));

  } catch(e) { console.error(e); }
})();
})();
